import React from 'react';

type ButtonVariant = 'primary' | 'accent' | 'outline';
type ButtonSize = 'sm' | 'md' | 'lg';

interface ButtonProps {
  variant?: ButtonVariant;
  size?: ButtonSize;
  /** Wenn gesetzt, wird ein <a> statt eines <button> gerendert */
  href?: string;
  type?: 'button' | 'submit';
  disabled?: boolean;
  onClick?: (event: React.MouseEvent) => void;
  className?: string;
  children: React.ReactNode;
}

const baseClasses =
  'inline-flex items-center justify-center font-medium rounded-lg shadow-sm ' +
  'transition-colors duration-200 cursor-pointer focus:outline-none ' +
  'focus-visible:ring-2 focus-visible:ring-offset-2 ' +
  'disabled:bg-gray-400 disabled:text-white disabled:border-transparent disabled:cursor-not-allowed';

const variantClasses: Record<ButtonVariant, string> = {
  primary: 'bg-primary text-white hover:bg-primary-dark focus-visible:ring-primary',
  accent: 'bg-accent text-white hover:bg-accent-dark focus-visible:ring-accent',
  outline: 'border border-primary bg-white text-primary hover:bg-primary-mist focus-visible:ring-primary',
};

const sizeClasses: Record<ButtonSize, string> = {
  sm: 'px-4 py-2 text-sm',
  md: 'px-6 py-3 text-base',
  lg: 'px-8 py-4 text-lg',
};

const Button: React.FC<ButtonProps> = ({
  variant = 'primary',
  size = 'md',
  href,
  type = 'button',
  disabled = false,
  onClick,
  className = '',
  children,
}) => {
  const classes = `${baseClasses} ${variantClasses[variant]} ${sizeClasses[size]} ${className}`;

  if (href) {
    return (
      <a href={href} onClick={onClick} className={classes}>
        {children}
      </a>
    );
  }

  return (
    <button type={type} disabled={disabled} onClick={onClick} className={classes}>
      {children}
    </button>
  );
};

export default Button;
